import { api, handleError } from "./baseApi";

export async function getKyc(user_id) {
  try {
    const { data } = await api.get("/kyc", {
      params: { user_id },
    });
    return data;
  } catch (error) {
    return handleError(error, "Failed to fetch KYC details");
  }
}

export async function updateKyc(kyc_id, kyc_type, kyc_value) {
  try {
    const { data } = await api.put(`/kyc/${kyc_id}`, {
      kyc_type,
      kyc_value,
    });
    return data;
  } catch (error) {
    return handleError(error, "Failed to update KYC");
  }
}

export async function createKyc(operator_id, kyc_type, kyc_value, user_type) {
  try {
    const { data } = await api.post(`/kyc`, {
      operator_id,
      user_type,
      kyc_type,
      kyc_value,
    }, {
      params: { user_type }, 
    });
    return data;
  } catch (error) {
    return handleError(error, "Failed to create KYC");
  }
}
